import { ChevronDown, Search } from 'lucide-react';
import React from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@components/ui/popover';
import { PopoverClose } from '@radix-ui/react-popover';

const statusData = ['', 'draft', 'pusblished', 'archived'];
const keyActions = ['Generate Blog', 'Create Blog'];

const SearchContent = ({
  handleSearch,
  searchString,
  handleStatus,
  selected,
  isBlogs,
  openGenerate
}) => {
  return (
    <div className="flex justify-between items-center mb-10 font-outfit">
      {!isBlogs ? (
        <div />
      ) : (
        <div className="max-w-[280px] flex items-center bg-[#F5F6FA] border border-[#E5E7EB] rounded-[10px] w-full px-4 min-h-[32px] gap-3">
          <Search size={13} />
          <input
            value={searchString}
            onChange={(e) => handleSearch(e.target.value)}
            className="w-full bg-transparent border-0 outline-none focus:border-0 focus:outline-none focus:ring-0 placeholder:text-[#9CA3AF] text-[13px] font-normal text-black px-1"
            placeholder="Search title…"
          />
        </div>
      )}

      <div className="flex gap-2 items-center">
        <Popover>
          <PopoverTrigger asChild>
            <button className="bg-[#FFFFFF] capitalize border border-[#E5E7EB] text-[12px] text-[#111827] py-2.5 px-3 rounded-lg flex items-center gap-3">
              Actions
              <ChevronDown size={13} color="#9CA3AF" />
            </button>
          </PopoverTrigger>
          <PopoverContent
            align="end"
            className={
              'bg-white max-w-[105px] border-0 outline-0 rounded-lg! ring-0 p-1 shadow-[0px_4px_8px_0px_#33333314]'
            }
          >
            {keyActions?.map((data) => (
              <PopoverClose
                key={data}
                onClick={() => {
                  if (data === 'Create Blog') {
                    window.location.href = '/new-story';
                    return;
                  }
                  openGenerate();
                }}
                className="text-left capitalize text-xs text-[#313030] hover:bg-gray-200 rounded-lg p-2 ease-in-out duration-300 transition-all"
              >
                {data}
              </PopoverClose>
            ))}
          </PopoverContent>
        </Popover>
        {isBlogs && (
          <Popover>
            <PopoverTrigger asChild>
              <button className="bg-[#FFFFFF] capitalize border border-[#E5E7EB] text-[12px] text-[#111827] py-2.5 px-3 rounded-lg flex items-center gap-3">
                {!selected ? 'All statuses' : selected}{' '}
                <ChevronDown size={13} color="#9CA3AF" />
              </button>
            </PopoverTrigger>
            <PopoverContent
              align="end"
              className={
                'bg-white max-w-[105px] border-0 outline-0 rounded-lg! ring-0 p-1 shadow-[0px_4px_8px_0px_#33333314]'
              }
            >
              {statusData?.map((data) => (
                <PopoverClose
                  key={data}
                  onClick={() => handleStatus(data)}
                  className="text-left capitalize text-xs text-[#313030] hover:bg-gray-200 rounded-lg p-2 ease-in-out duration-300 transition-all"
                >
                  {data || 'All statuses'}
                </PopoverClose>
              ))}
            </PopoverContent>
          </Popover>
        )}
      </div>
    </div>
  );
};

export default SearchContent;
